import { monthYearDateFormat } from "@modules/utils/dateUtils"
import { useQueryParam } from "@modules/utils/navigation/useQueryParam"
import dayjs from "dayjs"
import { useEffect } from "react"

export const usePeriodParam = (): readonly [string, (v: string) => void] => {
  const [period, setPeriod] = useQueryParam("period")
  useEffect(() => {
    if (!!period && !dayjs(period).isValid()) {
      setPeriod(dayjs().format(monthYearDateFormat))
    }
  }, [period])

  const validPeriod = !!period && dayjs(period).isValid() ? period : dayjs().format(monthYearDateFormat)
  return [validPeriod, setPeriod] as const
}
